import AudioContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/AudioContent";
import File from "../../../../../lib/html5-software-library/src/ranj/eng/content/File";
import ImageContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/ImageContent";
import MovieContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/MovieContent";
import Config from "../../../core/config/Config";

export default class FileAssetLocator {
    /**
     * @constructor
     * @param {Config} config 
     */
    constructor(config) {
        this._config = config;
    }

    /**
     * Gets the content location from file content
     * @param {File} file 
     * @returns {String} The path to the content asset
     */
    getFileLocationById(file) {
        const content = file.getContent();

        if (content instanceof ImageContent) {
            return `assets/files/images/${content.getImage()}.png`;
        }
        if (content instanceof MovieContent) {
            if (this._config.getValue("settings.useHLS")) {
                return `assets/files/movies/hls/${content.getMovie()}/${content.getMovie()}.m3u8`;
            } else {
                return `assets/files/movies/${content.getMovie()}.mp4`;
            }
        }
        if (content instanceof AudioContent) {
            return `assets/files/images/${content.getAudio()}.mp3`;
        }

        console.error(`Unhandled file content type.`, content);
    }
}